import NomenclatureListPage from "../../../common/nomenclatures/NomenclatureListPage";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import {
  breakTypeSchema,
  getBreakTypeDefaults,
  IBreakTypeInputModel,
} from "./models/breakTypeInputModel";
import { BreakTypeListItem } from "./components/BreakTypeListItem";
import { BreakTypeFormFields } from "./components/BreakTypeFormFields";
import { OnboardingItemKey } from "../../../common/enums";
import { usePageGuide } from "../../onboarding/hooks/usePageGuide";

export const BreakTypesNomenclature = () => {
  usePageGuide(OnboardingItemKey.BreakTypesGuide);

  return (
    <NomenclatureListPage<IBreakTypeInputModel, IBreakTypeInputModel>
      endpoints={endpointsMetadata.breakTypeNomenclature}
      title="Типове блокирания"
      description="Типовете блокирания са шаблони за блокирано време в календара."
      dialogAddTitle="Добавяне на нов тип блокиране"
      dialogEditTitle="Редактиране на тип блокиране"
      emptyListText="В момента нямате добавени типове блокирания"
      itemTemplate={(item, index, isLoading, actionButtons, className) => (
        <BreakTypeListItem
          item={item}
          isLoading={isLoading}
          actionButtons={actionButtons}
          className={className}
        />
      )}
      formSchema={breakTypeSchema}
      defaultValues={() => getBreakTypeDefaults()}
      formFields={<BreakTypeFormFields />}
      editOnRowClick
      deletedFilter={{
        storageKey: "breakTypes",
        sectionTitle: "Изтрити типове блокирания",
        toggleLabel: "Покажи изтритите типове блокирания",
      }}
    />
  );
};
